import classNames from 'classnames';
import React from 'react';
import { ResponseNativeCard, ResponseStoreFrontSmeLoan } from '@/src/interfaces/data-contracts';

type Props = {
  children: React.ReactNode;
  className?: string;
  item?: ResponseNativeCard;
  isNativeCard?: boolean;
};

const Badge: React.FC<{
  text: string | React.ReactNode;
  className: string;
}> = ({ text, className }) => (
  <div
    className={classNames(
      'absolute left-px top-px flex h-[32px] items-center rounded-br-xl rounded-tl-xl px-4 text-xs font-bold',
      className
    )}
    data-testid="badge"
  >
    {text}
  </div>
);

const productTypeBadgeMapping: Record<number, string> = {
  0: 'bg-green100 text-green600',
  1: 'bg-warningLight text-warning',
  2: '',
  3: 'bg-purple100 text-purple500',
  4: 'bg-gray-200 text-gray-800',
  5: 'bg-gray-200 text-gray-800',
  6: 'bg-blue100 text-intro',
};

const productTypeGradientMapping: Record<number, string> = {
  0: 'gradientGreenBorderBg',
  1: 'gradientYellowBorderBg',
  2: '',
  3: 'gradientPurpleBorderBg',
  4: 'gradientGrayBorderBg',
  5: 'gradientGrayBorderBg',
  6: 'gradientBlueBorderBg',
};

export const NCContainer: React.FC<Props> = ({ children, className, item, isNativeCard }) => {
  const badgeClass =
    item && typeof item.productType === 'number'
      ? productTypeBadgeMapping[item.productType] || ''
      : 'bg-gray-200 text-gray-800';

  const gradientBorderClass =
    item && typeof item.productType === 'number'
      ? item.productType === 2
        ? 'bg-white shadow-campCard'
        : productTypeGradientMapping[item.productType] || ''
      : '';

  return (
    <div
      className={classNames(
        'relative w-full rounded-xl',
        { 'rounded-xl bg-white pt-8 shadow-campCard md:pt-0': !isNativeCard },
        className,
        gradientBorderClass
      )}
      data-testid="product"
    >
      {item && item.productTypeText && (item.productType as unknown as number) !== 2 && (
        <Badge text={item.productTypeText} className={badgeClass} />
      )}
      {children}
    </div>
  );
};
